import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Centers from './views/Centers.vue';
import Center from './views/Center.vue';
import SelectGame from './views/SelectGame.vue';
import FootbowlGame from './views/FootbowlGame.vue';
import Account from './views/Account.vue';
import Health from './views/Health.vue';
import { INFO_SITE } from './config';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter() {
        if (INFO_SITE) {
          window.location.href = INFO_SITE;
        }
      },
      meta: {
        hideNav: false,
      },
    },
    {
      path: '/footbowl/:center/lane/:lane',
      name: 'footbowl',
      component: FootbowlGame,
      meta: {
        hideNav: true,
      },
    },
    {
      path: '/footbowl/:gameId',
      name: 'footbowlById',
      component: FootbowlGame,
      meta: {
        hideNav: true,
      },
    },
    {
      path: '/centers',
      name: 'centers',
      component: Centers,
    },
    {
      path: '/center/:centerCodeOrId',
      name: 'center',
      component: Center,
    },
    {
      path: '/selectGame',
      name: 'selectGame',
      component: SelectGame,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/SignUp.vue'),
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
    },
    {
      path: '/health',
      name: 'health',
      component: Health,
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: () => import('./views/Leaderboard.vue'),
    },
    {
      path: '/leaderboard/:id',
      name: 'leaderboardById',
      component: () => import('./views/Leaderboard.vue'),
    },
  ],
});
